import React from 'react'
import { Row, Col, Image, Table, Spin } from 'antd'
import '../../App.css'
import { useEffect } from 'react'
import { useState } from 'react'
import axios from 'axios';
import { osintRequestAddress } from '../config'

const infoBoxCcolumns = [
    {
      title: '属性项',
      dataIndex: 'label',
      key: 'label',
      width: '30%', 
      align: 'center',    
    },
    {
      title: '属性值',
      dataIndex: 'value',
      key: 'value',
    },
]

const PlaneInfoBox = (props) => {
    const [photos, setPhotos] = useState([])
    const [loading, setLoading] = useState(false)
    const { plane } = props
    useEffect(() => {
        getPhotos(plane.reg)
    }, [plane.reg])
    const getPhotos = (reg) => {
        setLoading(true)
        axios.get(`${osintRequestAddress}/plane/photo?reg=` + reg).then(
            response => {
                if (response.data && response.data.length > 0){
                    setPhotos(response.data.slice(0,10))
                } else {
                    setPhotos(['https://img2-bs.511doc.com/mark/00/00/38/05/0c261c78c84ec50ccebbeb5143b66d6e.jpg!/quality/90/unsharp/true/compress/true/fw/640/clip/640x500a0a0'])
                }
                setLoading(false)
            },
            error => {
                console.log("error",error)
                setLoading(false)
            }
        )
    }
    return (props.planeinfobox && props.planeinfobox.length > 1) ?
            (<div>
                <Row align='middle' justify='center'>
                    <Col span={12} > 
                        <Row align='middle' justify='center'>
                            <Spin spinning={loading}>
                                <Image
                                    key={photos[0]} 
                                    src={photos[0]} 
                                    width={'30vw'} 
                                    preview={false}
                                >
                                </Image>
                            </Spin>
                        </Row>
                    </Col>
                    <Col span={12} >
                        <Table columns={infoBoxCcolumns} showHeader={false} dataSource={props.planeinfobox} size="small" pagination={{hideOnSinglePage:true}}></Table>
                    </Col>
                </Row>
            </div>) : ''
}

export default PlaneInfoBox